// ANCHOR TAG BEHAVIOR - v1.23 - April 2025 - Vanilla !
(function () {
'use strict'; // This directive ensures that the code is executed in strict mode, 
// catching common coding mistakes and preventing the use of unsafe features.
document.addEventListener('DOMContentLoaded', function () {


	const DEV = 0


	const selectors = {
        noHref: '*[href=""], *[href="#"]',
        hamburger: '#hamburger_container',
        pageOverlay: '.page_overlay',
        mobileMenuContainer: '#nav_mobile_container',
        loadingBar: '#loading_bar'
    };

    let actual_url_with_no_hash = window.location.origin + window.location.pathname + window.location.search
	let actual_full_url = document.location.toString()
	log('actual_url_with_no_hash', actual_url_with_no_hash)
	log('actual_full_url', actual_full_url)


    function log(...args) {
        if (DEV) {
            console.log(...args);
        }
    }


    function addNoHrefClass() {
        document.querySelectorAll(selectors.noHref).forEach(element => {
            element.classList.add('no_href');
        });
    }

    function getOffsetTopRelativeToPage(element) {
	    let offsetTop = 0;
	    // Traverse through the element's offsetParent chain
	    while (element) {
	        offsetTop += element.offsetTop;
	        element = element.offsetParent;
	    }
	    return offsetTop;
	}

	function gotoAnchorOnSamePage(event, anchor, full_url) {
		log('Anchor is on same page')
		const offset = 200
		const target = findAnchorTarget(anchor);
		if(!target) {
			log("didn't find any target on the page !!")
			return false;
		}
		let offsetTop = getOffsetTopRelativeToPage(target);
		log('offsetTop', offsetTop)
		let topPosition = offsetTop - offset;
	    window.scrollTo({
	        top: topPosition,
	        behavior: 'smooth'
	    });
	    window.history.pushState('', '', full_url);
		closeMobileMenu();
		return false;		
	}


	function findAnchorTarget(anchor) {
		let target = document.getElementById(anchor);
		if(target) {		
			log('Target id exists')	
			return target
		} 
		target = document.querySelector(`*[name="${anchor}"]`);
		if (target) {
			log('Target with name attribute exists')
			return target
		} 
		return false;
	}


	function closeMobileMenu() {
		const hamburger = document.querySelector(selectors.hamburger);
        const pageOverlay = document.querySelector(selectors.pageOverlay);
        const mobileMenuContainer = document.querySelector(selectors.mobileMenuContainer);

	    if (hamburger && hamburger.classList.contains('is-active')) {
	        hamburger.classList.remove('is-active', 'back-arrow');
	        if (pageOverlay.classList.contains('active')) {
	            pageOverlay.classList.add('remove-active');
	            pageOverlay.classList.remove('active');
	        }
	        mobileMenuContainer.classList.remove('opened');
	        unfix_body();
	    }
	}


	function launchLoadingBar() {
		document.querySelector(selectors.loadingBar).style.width = '100%';
	}




	// MAIN FUNCTION
	function handleAnchorClick(e) {
        const target = e.target.closest('a');
        if (!target) return;

		// Check if Command (Mac) or Windows key is pressed
		if (e.metaKey || e.ctrlKey) return;

        const customEvent = {
            ...e,
            currentTarget: target,
            preventDefault: e.preventDefault.bind(e),
            stopPropagation: e.stopPropagation.bind(e)
        };

        loadAnchor(customEvent);
    }



	function loadAnchor(e) {

		log('e', e)

		const currentTarget 		= e.currentTarget
		const href 					= currentTarget.href
		const href_slug 			= href.split("/").pop()
		const elementClasses 		= currentTarget.classList;
		const parentElementClasses  = currentTarget.parentElement.classList
		const mobileContainer = document.querySelector(selectors.mobileMenuContainer);

		const conditions = {
            isException: false,
            isGoBack: false,
            hasNoHref: false,
            hasChildren: false,
            toAnchor: false,
            isMailto: false,
            isMobileAndHasChildren: false,
            isCommentReply: false,
            isDownload: false,
            isOutside: false,
            isForceReload: false,
            isLogout: false
        };

		var arrayClassesExceptions = [
			'ajax_add_to_cart', 'tinvwl_add_to_wishlist_button', 'ab-item',
			'wpecp-edit-comment', 'wpecp-submit-edit', 'wpecp-cancel-edit',
			'slide', 'wpml-ls-item-toggle', 'gform_save_link', 'cn-set-cookie', 
			'sce-edit-button-main', 'k-link', 'remove', 'wdgk_add_donation', 
			'mejs-horizontal-volume-slider'
		]


		if (currentTarget.hasAttribute('tabindex')) conditions.isException = true;


		elementClasses.forEach(cls => {
            if (arrayClassesExceptions.includes(cls)) conditions.isException = true;
            if (cls === "goBack") conditions.isGoBack = true;
            if (cls === "no_href") conditions.hasNoHref = true;
            if (cls === "toAnchor") conditions.toAnchor = true;
            if (cls === "forceReload") conditions.isForceReload = true;
            if (cls === "comment-reply-link") conditions.isCommentReply = true;
            if (cls === "woocommerce-MyAccount-downloads-file") conditions.isDownload = true;
            if (cls === "logOut") conditions.isLogout = true;
        });

		parentElementClasses.forEach(cls => {
            if (cls === "menu-item-has-children") conditions.hasChildren = true;
	        if (mobileContainer && mobileContainer.contains(currentTarget) && conditions.hasChildren) {
	            conditions.isMobileAndHasChildren = true;
	        }
        });


		if (conditions.isException) return true;

		// LOGOUT
		if (conditions.isLogout) {
            handleLogout(e);
            return;
        }

		// check if url has hash + name (for footnotes for example)
		if(currentTarget.hash && currentTarget.name){ 
			handleAnchorWithHashAndName(e, currentTarget);
			return false;
		}

		// MAILTO && TEL
		if(currentTarget.protocol === "mailto:" || currentTarget.protocol === "tel:" ) {
			log('isMailto', true);
			return false;
		}

		// IS OUTSIDE
		if(currentTarget.hostname !== document.location.hostname) {
			conditions.isOutside = true
			log('isOutside', true);
		}

		// IS FORCE RELOAD
		if(conditions.isForceReload) {
			log('isForceReload', true)
			launchLoadingBar()
			window.history.pushState('', '', actual_full_url);
			window.location = href;	
			return false;
		}

		// COMMENT REPLY
		if(conditions.isCommentReply) {
			log('isCommentReply', e)
			var comment_id = currentTarget.dataset.commentid
			log('comment_id', comment_id)
			document.querySelector('#commentform input#comment_parent').value = comment_id;
			window.location.href = href;
			return false;
		}

		// IS DOWNLOAD
		if (href.includes('.mp3') || conditions.isDownload) {
			log('is download')
			e.preventDefault();
			window.open(href, '_blank');
		}

		// HAS INLINE JS
		if(currentTarget.onclick) {
			log('hasInlineJS')
			return true;
		}


		if (conditions.toAnchor || (currentTarget.hash && !conditions.isOutside)) {
			return handleAnchorNavigation(e, currentTarget, href);
		}
		

		// CURRENT TARGET = ACTUAL URL
		if(href === actual_url_with_no_hash && !conditions.hasNoHref 
			&& !conditions.isMobileAndHasChildren) {
			e.preventDefault();
			log('scrolling-up')
			smoothScroll(document.getElementById('body_wrapper'))
			closeMobileMenu();

		} else {
			e.preventDefault();
			if (currentTarget.target === "_blank" && !conditions.hasNoHref) {
				window.open(href,'_blank');

			} else if (conditions.isGoBack) {
				launchLoadingBar()
				// window.history.back()  // not working on Safari :/

				if (isSessionStorageAvailable() && sessionStorage.getItem('previous_url')) {
					window.location.replace(sessionStorage.getItem('previous_url'));
				} else {
					window.location.replace(appInfo.home)
				}

			} else if (!conditions.isException && !conditions.isMobileAndHasChildren 
				&& !conditions.hasNoHref && !conditions.isDownload) {

				if (isSessionStorageAvailable()) {
					sessionStorage.setItem('previous_url', actual_full_url);
				}
				
				launchLoadingBar()
				window.history.pushState('', '', actual_full_url);
				window.location = href;	
			}
		}
	}





	function handleLogout(e) {
        log('isLogout', true);
        e.preventDefault();

        launchLoadingBar();

        const xhr = new XMLHttpRequest();
        xhr.open('POST', appInfo.ajax_url, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
            	// Redirect to the stored page URL after successful logout
                window.location.href = window.location.href;
            }
        };

        xhr.send('action=custom_logout');
    }



    function handleAnchorWithHashAndName(e, currentTarget) {
        e.preventDefault();
        const hash = currentTarget.hash.substring(1);
        log('url has anchor + name. Hash name is', hash);

        let element = document.getElementById(hash) || document.querySelector(`*[name="${hash}"]`);
        if (element) {
            smoothScroll(element, { offset: 120 });
        } else {
            log('no element');
        }
    }



	function handleAnchorNavigation(e, currentTarget, href) {

		e.preventDefault();
		
		log('Url has an anchor');

		const full_url = href;
		const anchor = full_url.substring(full_url.indexOf("#") + 1);
		const targetUrlWithoutAnchor = full_url.split("#")[0];
		log('full_url', full_url);
		log('anchor', anchor);
		log('targetUrlWithoutAnchor', targetUrlWithoutAnchor);

		// If href only has a hash, no url
		if (currentTarget.getAttribute('href').startsWith("#")) {
			log('href only has a hash, no url');
			return gotoAnchorOnSamePage(e, anchor);
		}

		// If href has a full url + hash
		if (targetUrlWithoutAnchor === actual_url_with_no_hash) {
			log('href has a full url + hash');
			return gotoAnchorOnSamePage(e, anchor, full_url);
		}

		log('Anchor is Not on same page');
		window.history.pushState('', '', actual_url_with_no_hash);
		if(isSessionStorageAvailable()) {
			sessionStorage.setItem('scrollOnLoad_anchor', anchor);
		}
		launchLoadingBar();
		window.location.href = targetUrlWithoutAnchor;
    }





	// SMOOTH SCROLL ANCHOR ON OTHER PAGE  ----------------------------
	function scrollToAnchorOnLoad() {
		if (isSessionStorageAvailable()) {
			const anchor = sessionStorage.getItem('scrollOnLoad_anchor');
			if (anchor) {
				log('scrollOnLoad_anchor', anchor)
				smoothScroll(document.getElementById(anchor), {offset:220})
				const updatedUrl = `${location.href}#${anchor}`;
				log('updatedUrl', updatedUrl)
				history.replaceState(null, '', updatedUrl);
				sessionStorage.removeItem('scrollOnLoad_anchor');
			}
		}
	}


	// TESTING SESSION STORAGE AVAILABILITY
	function isSessionStorageAvailable() {
	    try {
	        const test = 'test';
	        sessionStorage.setItem(test, test);
	        sessionStorage.removeItem(test);
	        return true;
	    } catch (e) {
	        log('sessionStorage is not available:', e);
	        return false;
	    }
	}



	// Event listeners
    document.addEventListener('click', handleAnchorClick);

    // Initialize functions
    addNoHrefClass();
    scrollToAnchorOnLoad();

}); // end DOMContentLoaded
})(); // IIFE (Immediately Invoked Function Expression)